import { handleActions } from 'redux-actions';

import { updateGuestEventsRequests } from './actions';

export default handleActions(
  {
    [updateGuestEventsRequests]: (state, { payload: { data } }) => ({
      ...state,
      ...data,
    }),
  },
  {},
);
